/** Names and message shapes shared by the main thread and the AudioWorklet module. */

export const METER_PROCESSOR = 'ohmyobs-meter';
export const GATE_PROCESSOR = 'ohmyobs-noise-gate';
export const COMPRESSOR_PROCESSOR = 'ohmyobs-compressor';
export const EXPANDER_PROCESSOR = 'ohmyobs-expander';
export const LIMITER_PROCESSOR = 'ohmyobs-limiter';

/** Every processor works on stereo; nodes are created with an explicit channel count of 2. */
export const WORKLET_CHANNELS = 2;

/** Frames per meter report. With two hops per window: ~43 ms at 48 kHz, ~46 ms at 44.1 kHz. */
export const METER_HOP_FRAMES = 1024;
export const METER_WINDOW_HOPS = 2;

export type WorkletMessage<P> = { type: 'params'; params: P } | { type: 'dispose' };

export const PROGRAM_ROUTE_PROCESSOR = 'ohmyobs-program-route';
